import React, { useEffect, useState } from 'react';
import { themeAPI } from '../../lib/api';
import { THEME_OPTIONS } from '../layout/SeasonalDecorations';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { Save, Sparkles } from 'lucide-react';

export const ThemeAdmin = () => {
  const [theme, setTheme] = useState('none');
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    themeAPI.get()
      .then(res => { setTheme(res.data?.theme || 'none'); setEnabled(res.data?.enabled ?? true); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await themeAPI.update(theme, enabled);
      toast.success('Motiv uložen');
    } catch (e) {
      const msg = e?.response?.status === 404 ? 'Backend ještě nemá tuto funkci. Redeployujte produkci.' : 'Nepodařilo se uložit';
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[40vh]"><div className="spinner" /></div>;

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl font-bold text-[#2C3E50] flex items-center gap-2"><Sparkles className="text-[#FF6B6B]" size={26} /> Sezónní motiv</h1>
        <p className="text-[#64748B]">Vyberte dekoraci, která se zobrazí na veřejném webu (sněžení, motýli, listí…). Změna se projeví okamžitě.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-6 space-y-6">
        <div className="flex items-center justify-between gap-4 pb-4 border-b border-slate-100">
          <div>
            <Label className="text-base">Zobrazit motiv na webu</Label>
            <p className="text-xs text-[#64748B]">Pokud vypnete, na webu se nezobrazí žádné sezónní dekorace.</p>
          </div>
          <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="theme-enabled-switch" />
        </div>

        <div>
          <Label className="mb-3 block">Motiv</Label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {THEME_OPTIONS.map(opt => (
              <button
                key={opt.key}
                type="button"
                onClick={() => setTheme(opt.key)}
                className={`p-4 rounded-2xl border-2 transition-all flex flex-col items-center gap-2 ${theme === opt.key ? 'border-[#4ECDC4] bg-[#E6FFFB] shadow-md scale-105' : 'border-slate-200 hover:border-[#4ECDC4] bg-white'}`}
                data-testid={`theme-option-${opt.key}`}
              >
                <span className="text-3xl">{opt.emoji}</span>
                <span className="text-sm font-medium text-[#2D3748]">{opt.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="pt-2">
          <Button onClick={save} disabled={saving} className="rounded-full bg-[#4ECDC4] hover:bg-[#3DBDB5]" data-testid="theme-save">
            <Save size={16} className="mr-2" />
            {saving ? 'Ukládání…' : 'Uložit motiv'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThemeAdmin;
